import * as firebase from 'firebase';
import 'firebase/firestore'

const devConfig = {
  apiKey: process.env.REACT_APP_DEV_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_DEV_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_DEV_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_DEV_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DEV_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DEV_FIREBASE_SENDER_ID
};

const prodConfig = {
  apiKey: process.env.REACT_APP_PROD_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_PROD_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_PROD_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_PROD_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_PROD_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_PROD_FIREBASE_SENDER_ID
};

const config = process.env.REACT_APP_ENV === 'production' ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export const isAuthenticated = () => {
  return !!(auth.currentUser || localStorage.getItem('firebaseUid'));
};

export { auth, db, storage, config };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js